var Handlebars = require("handlebars/runtime");
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, alias2=container.propertyIsEnumerable;

  return "    <div class=\"modal-button\" buttonId=\""
    + alias1(container.lambda(depth0, depth0))
    + "\">"
    + alias1((helpers.translate||(depth0 && depth0.translate)||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"translate","hash":{},"data":data,"loc":{"start":{"line":2,"column":50},"end":{"line":2,"column":68}}}))
    + "</div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.propertyIsEnumerable;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? depth0.viewData : depth0)) != null ? stack1.buttons : stack1),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":3,"column":9}}})) != null ? stack1 : "");
},"useData":true});